import React, { forwardRef } from 'react'

import { Select } from '../Select'

export const DataSelect = forwardRef(
  (
    {
      data,
      isError,
      isErrorLabel = 'Occoreu um erro',
      isDisabled,
      valuePath,
      labelPath,
      placeholder = 'Escolha uma opção',
      ...props
    },
    ref
  ) => (
    <Select
      {...props}
      ref={ref}
      isDisabled={isError || isDisabled}
      placeholder={isError ? isErrorLabel : placeholder}>
      {data &&
        data?.map((item, index) => (
          <option value={valuePath ? item[valuePath] : item} key={index}>
            {labelPath ? item[labelPath] : item}
          </option>
        ))}
    </Select>
  )
)

export default DataSelect
